// extracted by mini-css-extract-plugin
export default {"container":"styles__container---2Yb2","top":"styles__top--HMeTn","bottom":"styles__bottom--qJ6se"};